import React, { useState } from 'react';
import styles from "./InfrastructureDashboard.module.css";
import { GET } from '../../../../config/api';

const InfrastructureDashboard = () => {
    const [commitInfo, setCommitInfo] = useState(null);
    const [loading, setLoading] = useState({ commit: false, deploy: false, logs: false });
    const [deployResult, setDeployResult] = useState(null);
    const [logsData, setLogsData] = useState(null);
    const [error, setError] = useState(null);

    const handleGetLastCommit = async () => {
        setLoading({ ...loading, commit: true });
        setError(null);
        try {
            const response = await GET('/website/admin/lastCommit');
            if (response.error) {
                setError(response.message || 'Failed to fetch commit info');
            } else {
                setCommitInfo(response.data);
            }
        } catch (err) {
            setError('Failed to fetch commit info');
        } finally {
            setLoading({ ...loading, commit: false });
        }
    };

    const handleDeploy = async () => {
        setLoading({ ...loading, deploy: true });
        setError(null);
        setDeployResult(null);
        try {
            const response = await GET('/website/admin/deploy');
            if (response.error) {
                setError(response.message || 'Failed to deploy');
            } else {
                setDeployResult(response.data);
            }
        } catch (err) {
            setError('Failed to deploy');
        } finally {
            setLoading({ ...loading, deploy: false });
        }
    };

    const handleGetLogs = async () => {
        setLoading({ ...loading, logs: true });
        setError(null);
        setLogsData(null);
        try {
            const response = await GET('/website/admin/logs');
            if (response.error) {
                setError(response.message || 'Failed to fetch logs');
            } else {
                setLogsData(response.data);
            }
        } catch (err) {
            setError('Failed to fetch logs');
        } finally {
            setLoading({ ...loading, logs: false });
        }
    };

    return(
        <div className={styles.container}>
            <h1>Infrastructure Dashboard</h1>
            
            <div className={styles.buttonsContainer}>
                <button 
                    className={styles.button}
                    onClick={handleGetLastCommit}
                    disabled={loading.commit}
                >
                    {loading.commit ? 'Loading...' : 'Get Last Commit'}
                </button>
                
                <button 
                    className={styles.button}
                    onClick={handleDeploy}
                    disabled={loading.deploy}
                >
                    {loading.deploy ? 'Deploying...' : 'Deploy'}
                </button>

                <button 
                    className={styles.button}
                    onClick={handleGetLogs}
                    disabled={loading.logs}
                >
                    {loading.logs ? 'Loading...' : 'Get PM2 Logs'}
                </button>
            </div>

            {error && (
                <div className={styles.error}>
                    <p>{error}</p>
                </div>
            )}

            {commitInfo && (
                <div className={styles.infoBox}>
                    <h2>Last Commit Information</h2>
                    <pre className={styles.codeBlock}>
                        {JSON.stringify(commitInfo, null, 2)}
                    </pre>
                </div>
            )}

            {deployResult && (
                <div className={styles.infoBox}>
                    <h2>Deployment Result</h2>
                    <pre className={styles.codeBlock}>
                        {JSON.stringify(deployResult, null, 2)}
                    </pre>
                </div>
            )}

            {logsData && (
                <div className={styles.infoBox}>
                    <h2>PM2 Logs (Last 100 Lines)</h2>
                    <pre className={styles.codeBlock}>
                        {logsData.logs || JSON.stringify(logsData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    )
};

export default InfrastructureDashboard;